import React from 'react';
import { motion } from 'framer-motion';
export function ResultsSection() {
  const stats = [{
    label: 'Rookie Path',
    range: '$40K–$80K',
    detail: 'First year average'
  }, {
    label: 'Operator Path',
    range: '$80K–$150K',
    detail: 'Years 2-4 average'
  }, {
    label: 'Leadership Path',
    range: '$150K+',
    detail: 'Elite performers'
  }, {
    label: 'Avg. Time to Promotion',
    range: '18 months',
    detail: 'For committed operators'
  }];
  return <section className="py-32 px-6 bg-[var(--forge-steel)] relative" data-id="element-117">
      <div className="absolute inset-0 opacity-5" data-id="element-118">
        <div className="absolute top-0 left-0 w-full h-px bg-[var(--forge-lava)]" data-id="element-119" />
        <div className="absolute bottom-0 left-0 w-full h-px bg-[var(--forge-lava)]" data-id="element-120" />
      </div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-121">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-122">
          <h2 className="text-5xl md:text-6xl font-black tracking-tighter mb-6" data-id="element-123">
            THIS IS WHAT{' '}
            <span className="text-[var(--forge-lava)]" data-id="element-124">PRESSURE</span> PRODUCES
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12" data-id="element-125">
          {stats.map((stat, index) => <motion.div key={stat.label} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="bg-[var(--forge-charcoal)] p-6 border border-[var(--forge-zinc)]/30" data-id="element-126">
              <div className="text-sm text-[var(--forge-gray)] mb-2 font-semibold tracking-wide uppercase" data-id="element-127">
                {stat.label}
              </div>
              <div className="text-3xl font-black text-[var(--forge-lava)] mb-2" data-id="element-128">
                {stat.range}
              </div>
              <div className="text-xs text-[var(--forge-gray)]" data-id="element-129">
                {stat.detail}
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="text-center" data-id="element-130">
          <p className="text-lg text-[var(--forge-white)] font-semibold" data-id="element-131">
            Results are earned. Nothing is guaranteed.
          </p>
        </motion.div>
      </div>
    </section>;
}